import React, { useState } from 'react';

export const TextInput = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
}) => (
  <div className="mb-4">
    <label className="block text-secondary text-sm font-bold mb-2">
      {label}
    </label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      className="shadow appearance-none border rounded w-full py-2 px-3 text-secondary leading-tight focus:outline-none focus:shadow-outline"
      placeholder={placeholder}
    />
  </div>
);

export const PasswordInput = ({ label, value, onChange, placeholder }) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="mb-4">
      <label className="block text-secondary text-sm font-bold mb-2">
        {label}
      </label>
      <div className="relative">
        <input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-secondary leading-tight focus:outline-none focus:shadow-outline"
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={toggleShowPassword}
          className="absolute inset-y-0 right-0 px-3 py-2"
        >
          <i className={`fas fa-eye${showPassword ? '' : '-slash'}`}></i>
        </button>
      </div>
    </div>
  );
};

export const FileDropzone = ({ label, onChange }) => {
  const [fileName, setFileName] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      onChange(file);
    } else {
      setFileName('');
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      setFileName(file.name);
      onChange(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <div className="flex items-center justify-center w-full">
      <label
        htmlFor="dropzone-file"
        className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <svg
            className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            />
          </svg>
          <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="font-semibold">Click to upload</span> or drag and
            drop
          </p>
        </div>
        <input
          id="dropzone-file"
          type="file"
          className="hidden"
          onChange={handleFileChange}
        />
        {fileName && (
          <p className="text-xs text-gray-500 dark:text-gray-400">{fileName}</p>
        )}
      </label>
    </div>
  );
};

export const TextareaInput = ({
  label,
  value,
  onChange,
  placeholder,
  disabled,
  className,
}) => (
  <div className={`${className} mb-4`}>
    <label
      className={`block text-secondary text-sm font-bold mb-2 ${disabled ? 'text-gray-400' : ''}`}
    >
      {label}
    </label>
    <textarea
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`shadow appearance-none border rounded w-full py-2 px-3 text-secondary leading-tight focus:outline-none focus:shadow-outline ${
        disabled ? 'bg-gray-200 cursor-not-allowed' : ''
      }`}
      placeholder={placeholder}
    />
  </div>
);

export const SelectInput = ({
  label,
  options,
  onChange,
  value,
  className,
  ...props
}) => {
  return (
    <div className={`w-64 ${className}`}>
      {label && (
        <label
          htmlFor="select-input"
          className="block text-sm font-medium text-secondary"
        >
          {label}
        </label>
      )}
      <select
        id="select-input"
        name="select-input"
        value={value}
        onChange={onChange}
        className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        {...props}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
